import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useDispatch } from "react-redux";

import * as ActionTypes from "Redux/actionTypes";

import * as Analytics from "services/analyticsUtag";
import { LabelConfiguration } from "services/labelBackgroundService";

import ajaxService from "utils/ajaxServices";
import {
  getCookieValue,
  componentResize,
  formatNumbersWithComma,
  getAmountOffValue,
  checkIsLowStock,
  options,
  getSelectedVariant,
  formatBytes,
  createMarkup,
} from "utils/helperServices";

import {
  Row,
  Col,
  Modal,
  CustomContainer,
  useRouter,
  Link,
} from "components/atoms/DependencyHelper";
import StepCounter from "components/atoms/stepCounter/StepCounter";
import ButtonWithIcon from "components/atoms/buttons/buttonWithIcon/ButtonWithIcon";
import Image from "components/atoms/image/image";
import LabelText from "components/atoms/label/LabelText";
import Tag from "components/atoms/tag/Tag";
import IconWithText from "components/molecules/iconWithText/IconWithText";
import CartProductOptions from "components/molecules/cartProductOptions/CartProductOptions";
import ChangeLabelWithOutOfStock from "components/molecules/changeLabel/ChangeLabelWithOutOfStock";

import labels from "../../../config/labels";
import config from "../../../config/index";
import types from "../../../config/types";
import { getAttributes } from "../../../config/queries";

import styles from "./CartProductCard.module.scss";

const CartProductCard = ({
  cartProductItems,
  dealSku,
  cartProduct,
  totalQuantity,
  removeCartProduct,
  updateCartProduct,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [updatePage, setUpdatePage] = useState(false);
  const [showDeal, setShowDeal] = useState(false);

  const [attributesForDeal, setAttributesForDeal] = useState(null);

  const router = useRouter();

  const dispatch = useDispatch();
  const setLoadingState = (isLoading) => dispatch({
    type: ActionTypes.SET_IS_LOADING,
    payload: isLoading
  });

  const isMobile = componentResize();
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;

  const { name, __typename } = cartProduct?.product || {};
  const { row_total_including_tax, row_total_original } =
    cartProduct?.prices || {};

  const isDealProduct = cartProduct?.product?.is_deal_product === 1;
  let isVASProduct = false;
  if (cartProduct?.parent_product_sku) {
    dealSku.forEach((prodSku) => {
      if (prodSku && cartProduct?.parent_product_sku == prodSku) {
        isVASProduct = true;
      }
    });
  }

  let paymentTerms = null;
  if (isVASProduct) {
    const dealProduct = cartProductItems.filter(
      (cartProduct) => cartProduct?.product?.is_deal_product === 1
    );
    paymentTerms = dealProduct[0]?.product?.payment_terms_label;
  }
  const handleTermLinkClick = () => {
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `${pageName}: vodasure ${name} T&Cs apply`,
    });
  };

  const optList = [];
  if (
    __typename === labels.lbl_product_typeName_configurable &&
    cartProduct.product.variants !== undefined &&
    cartProduct.product.variants.length > 0
  ) {
    const optionsList = cartProduct?.product?.configurable_options.map(
      (val) => {
        const { attribute_code, attribute_id } = val || {};
        let obj = {
          attribute_code,
          attribute_id,
        };
        return obj;
      }
    );

    let productOptions;
    try {
      if (
        cartProduct?.product?.configurable_options?.[1]?.position >
        cartProduct?.product?.configurable_options?.[0]?.position
      ) {
        productOptions = cartProduct?.product?.configurable_options.sort(
          (a, b) => b.position - a.position
        );
      } else {
        productOptions = cartProduct?.product?.configurable_options;
      }
    } catch (error) {
      productOptions = cartProduct?.product?.configurable_options;
    }

    optionsList.forEach((option) => {
      const optionVal = options(productOptions, option.attribute_code).map(
        (opt) => {
          const { label, swatch_data, value_index } = opt || {};
          let obj = {
            label,
            swatch_data,
            value_index,
            attribute_id: option.attribute_id,
          };
          return obj;
        }
      );
      const variantsProducts = cartProduct?.product?.variants;
      const inStockOptionList = {};
      for (const oVal of optionVal) {
        for (const variant of variantsProducts) {
          for (const attr of variant.attributes) {
            if (
              oVal.label === attr.label &&
              (variant.product.stock_status === labels.lbl_in_stock ||
                variant.product.quantity > 0)
            ) {
              inStockOptionList[oVal.value_index] = oVal;
            }
          }
        }
      }

      let optionObj = {};

      optionObj[option.attribute_code] = Object.values(inStockOptionList);
      optList.push(optionObj);
    });
  }
  let cartId;

  let regularPrice,
    regularPriceString,
    finalPrice,
    finalPriceString,
    selectedVariant,
    small_image,
    promoTag,
    promoBadge,
    lowStockFlag,
    lowStockCount,
    promoForDeal,
    nonPromoArray,
    vasDescription,
    vasTermLink;

  const cartProductQuantity = cartProduct?.quantity;
  let optionObj = {};
  if (
    __typename === labels.lbl_product_typeName_configurable &&
    cartProduct.product.variants !== undefined &&
    cartProduct.product.variants.length > 0
  ) {
    const getLabel = (label) => {
      const headingObj = cartProduct?.product?.configurable_options.find(
        (config) => config.attribute_code === label[0]
      );
      return headingObj?.label;
    };
    optList.forEach((obj) => {
      cartProduct?.configurable_options.forEach((addedOption) => {
        if (getLabel(Object.keys(obj)) === addedOption.option_label) {
          optionObj[Object.keys(obj)] = addedOption.value_label;
        }
      });
    });
    selectedVariant = getSelectedVariant(
      cartProduct?.product?.variants,
      optionObj
    );
    small_image = selectedVariant?.product?.small_image?.url;
    promoTag = cartProduct?.product?.promotion_tag_label;
    promoBadge = cartProduct?.product?.promotion_tag;
    lowStockFlag = checkIsLowStock(selectedVariant?.product);
    lowStockCount = selectedVariant?.product?.quantity;
  } else {
    small_image = cartProduct?.product?.small_image?.url;
    promoTag = cartProduct?.product?.promotion_tag_label;
    promoBadge = cartProduct?.product?.promotion_tag;
    lowStockFlag = checkIsLowStock(cartProduct?.product);
    lowStockCount = cartProduct?.product?.quantity;
  }
  

  if (isDealProduct || isVASProduct) {
    finalPrice = isDealProduct
      ? cartProduct?.product?.monthly_recurring
      : cartProduct?.monthly_recurring;
    regularPrice = cartProduct?.product?.old_monthly_recurring;
    finalPriceString = `R${formatNumbersWithComma(finalPrice)} × ${
      paymentTerms == null
        ? cartProduct?.product?.payment_terms_label
        : paymentTerms
    }`;
    regularPriceString = `R${formatNumbersWithComma(regularPrice)} × ${
      paymentTerms == null
        ? cartProduct?.product?.payment_terms_label
        : paymentTerms
    }`;
    lowStockFlag = false;
    if (isDealProduct) {
      promoForDeal = cartProduct?.product?.items?.find(
        (deal) => deal.title === "Promo"
      )?.options[0]?.label;
      const nonPromoValues = cartProduct?.product?.items?.filter(
        (deal) => deal.title !== "Promo" && deal.title !== "Smartphones"
      );

      nonPromoArray = nonPromoValues
        ?.map((nPmv) =>
          nPmv.options.reduce((prouctAcc, prod) => {
            if (prod?.is_hidden_product === "0") {
              prouctAcc.push(prod.label);
            }
            return prouctAcc;
          }, [])
        )
        .flat();
    }

    if (isVASProduct) {
      let categories = cartProduct?.product?.categories.sort(
        (a, b) => b.level - a.level
      )[0];
      vasDescription = cartProduct?.product?.description;
      if (cartProduct?.product?.promotion_link) {
        vasTermLink = cartProduct?.product?.promotion_link;
      } else {
        vasTermLink = categories?.category_url ? categories?.category_url : "#";
      }
      if (
        cartProduct?.product?.image.url.match("No_image") ||
        cartProduct?.product?.image.url == null
      ) {
        small_image = categories?.image;
      } else {
        small_image = cartProduct?.product?.image.url;
      }
    } else {
      small_image = cartProduct?.product?.primary_product_image;
    }
  } else {
    finalPrice = row_total_including_tax?.value;
    regularPrice = row_total_original?.value;
    finalPriceString = `R${formatNumbersWithComma(finalPrice)}`;
    regularPriceString = `R${formatNumbersWithComma(regularPrice)}`;
  }

  const renderPage = () => {
    setUpdatePage(true);
  };

  useEffect(() => {
    setUpdatePage(false);
  }, [updatePage]);

  const removeProductFromCart = async () => {
    cartId = getCookieValue("cart_id");
    await removeCartProduct(
      cartId,
      cartProduct.id,
      cartProduct?.product?.name,
      cartProduct?.product?.is_deal_product
    );
    const analyticsData = {
      sales_event: "cart_remove",
      sales_order_discount: [getAmountOffValue(cartProduct?.product)],
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal",
      sales_product_category: [cartProduct?.product?.categories?.[0]?.name],
      sales_product_id: [cartProduct?.product?.name],
      sales_product_price: [finalPrice],
      sales_product_quantity: [cartProductQuantity],

      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_msisdn_hash",
        "visitor_id_hash",
      ]),
    };
    analyticsData.link_type = "o";
    analyticsData.link_name = "shopping: cart: remove";

    if (cartProduct?.product?.promotion_tag_label) {
      analyticsData.sales_promo_name = [
        cartProduct?.product?.promotion_tag_label,
      ];
    }
    Analytics.link(analyticsData);
  };

  const stepIncrement = async () => {
    cartId = getCookieValue("cart_id");
    let qty;
    qty = cartProductQuantity + 1;
    await updateCartProduct(cartId, cartProduct.id, qty);
  };

  const stepDecrement = async () => {
    cartId = getCookieValue("cart_id");
    let qty;
    if (cartProductQuantity > 1) {
      qty = cartProductQuantity - 1;
      isDealProduct || isVASProduct
        ? await updateCartProduct(
            cartId,
            cartProduct.id,
            qty,
            cartProduct?.product?.name,
            cartProduct?.product?.is_deal_product
          )
        : await updateCartProduct(cartId, cartProduct.id, qty);
    }
  };

  const promotionLabelColor = LabelConfiguration(promoTag ? promoTag : "");

  const showOptions = () => {
    setShowModal(true);
  };
  const closeOptions = () => {
    setShowModal(false);
  };

  const renderChangeLable = () => {
    setModalShow(true);
  };

  const closeChangeable = () => {
    setModalShow(false);
  };

  const showModel = optList && optList.length > 0;

  const PriceComponent = (
    <div
      className={`
        ${
          styles[isMobile ? "price-container" : `cart-product--price-container`]
        }
        ${
          styles[
            cartProduct?.hasBackOrderLabel ||
            cartProduct?.product?.promotion_tag_label == types.TYPE_PREORDER
              ? "promo-top-spacing"
              : ""
          ]
        }
      `}
    >
      {cartProduct?.isOutOfStock && !cartProduct?.hasBackOrderLabel ? (
        <div className={styles["out-of-stock-label"]}>
          {isDealProduct
            ? labels.lbl_menu_top.lbl_deal_404_heading
            : labels.lbl_menu_top.lbl_product_404_label}
        </div>
      ) : (
        <>
          {finalPrice !== regularPrice && !!regularPrice && (
            <label
              className={
                isDealProduct
                  ? styles["cart-product--deal-price"]
                  : styles["cart-product--price"]
              }
            >
              {regularPriceString}
            </label>
          )}

          <label className={styles["cart-product--finalprice"]}>
            {finalPriceString}
          </label>
        </>
      )}
    </div>
  );

  const isRenderStepCounter = () => {
    if (isDealProduct || isVASProduct) {
      return false;
    }
    if (
      cartProduct?.product?.is_deal_product === 0 &&
      cartProduct?.product?.stock_status !== labels.lbl_out_of_stock &&
      (cartProduct?.parent_product_sku == null ||
        cartProduct?.parent_product_sku == "")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const RenderRightComponent = (
    <Col md={4} className={styles["cart-product-options"]}>
      <div
        className={ `${styles["cart-product--display"]}
          ${ styles[cartProduct?.product?.promotion_tag_label == types.TYPE_PREORDER
              ? "promo-top-spacing"
              : ""
            ]
          }
        `}
      >
        {isRenderStepCounter() && (
          <div style={{ top: 0 }}>
            <StepCounter
              id={cartProduct?.id}
              value={cartProductQuantity}
              stepDecrement={stepDecrement}
              stepIncrement={stepIncrement}
              totalQuantity={totalQuantity}
              disableIncrement={
                lowStockFlag && lowStockCount === cartProductQuantity
                  ? true
                  : false
              }
            />
          </div>
        )}

        {PriceComponent}
      </div>
      <div
        className={
          !isVASProduct
            ? styles["cart-product--buttons"]
            : styles["cart-product-vas--buttons"]
        }
      >
        <ButtonWithIcon
          buttonLabelStyle={styles["action-btn"]}
          labelText={labels.lbl_remove}
          img_url_inactive={`${imagePrefix}/assets/images/icon-trash-inactive.svg`}
          img_url_active={`${imagePrefix}/assets/images/icon-trash-active.svg`}
          img_width={18}
          img_height={18}
          clickHandler={
            (isDealProduct || isVASProduct) && cartProductQuantity > 1
              ? stepDecrement
              : removeProductFromCart
          }
          id={labels.lbl_remove}
        />
      </div>
    </Col>
  );
  const optionValues = optionObj && Object.values(optionObj);

  async function fetchData() {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      getAttributes,
      {
        sku: cartProduct?.product?.primary_product_sku,
      }
    );
    if (result && result.products) {
      setAttributesForDeal(result.products);
    }
  }

  useEffect(() => {
    if (cartProduct?.product?.is_deal_product === 1) {
      fetchData();
    }
  }, []);

  const attributeCode = attributesForDeal?.items[0]?.attribute_set_id;
  const attributeVals = attributesForDeal?.attribute_set_config
    ?.find((val) => val.attribute_set_id == attributeCode)
    ?.configurable_product_attribute_set_attributes?.split(",");
  const updatedLabels = attributeVals?.map((val) => {
    return `${val}_label`;
  });

  let dealOptions = [];

  if (Array.isArray(attributesForDeal?.items) && Array.isArray(updatedLabels)) {
    for (const attr of attributesForDeal.items) {
      for (const label of updatedLabels) {
        if (attr[`${label}`]) {
          dealOptions.push(attr[`${label}`]);
        }
      }
    }
  }

  const promoSection = (
    <>
      {promoTag && promoBadge ? (
        <CustomContainer
          className={styles["promo-container"]}
          style={{ marginLeft: showDeal && isMobile ? "-6.5rem" : "" }}
        >
          <Image
            className={styles.img}
            img_path={`${imagePrefix}/assets/images/icon-buy-tag.svg`}
            img_width="0.8125rem"
            img_height="0.8125rem"
          />

          <LabelText className={styles["promo-label"]}>
            {labels.lbl_promotion}
          </LabelText>
          <LabelText
            className={styles["promo-label-name"]}
            style={{ color: promotionLabelColor }}
          >
            {promoTag}
          </LabelText>
        </CustomContainer>
      ) : null}
    </>
  );

  const vasSection = (
    <>
      {isVASProduct && !isMobile && vasTermLink ? (
        <CustomContainer
          className={styles["promo-container"]}
          style={{ marginLeft: showDeal && isMobile ? "-6.5rem" : "" }}
        >
          <Link legacyBehavior href={vasTermLink} passHref={true}>
            <a
              target="_blank"
              onClick={handleTermLinkClick}
              className={`${styles["vas-link"]}`}
            >
              T&Cs apply
            </a>
          </Link>
        </CustomContainer>
      ) : null}
    </>
  );

  const renderLowStockTag = () => {
    return (
      <>
        <CustomContainer className={styles["low-stock-tag"]}>
          <LabelText className={styles["stock-label"]}>
            Only {lowStockCount} left!
          </LabelText>
        </CustomContainer>
      </>
    );
  };

  const renderBackOrderTag = () => {
    return (
      <CustomContainer className={styles["order-tag--container"]}>
        <Tag
          className={styles["order-tag--label"]}
          label="Currently on backorder"
          variant="on-backorder"
        />
      </CustomContainer>
    );
  };

  const renderPreOrderTag = () => {
    return (
      <CustomContainer className={styles["order-tag--container"]}>
        <Tag
          className={styles["order-tag--label"]}
          label="Pre-order"
          variant="pre-order"
        />
      </CustomContainer>
    );
  };

  const renderRenderSelectedSpecs = () => {

    if (cartProduct?.isDoubleDeal) {
      const primaryName = cartProduct?.colorSelection?.product?.name;
      const primaryColor = cartProduct?.colorSelection?.label;
  
      return (
        <CustomContainer className={styles["product-details"]}>
          <label className={styles["product-details--title"]}>
            Primary Device:
          </label>

          <label className={styles["product-details--device-name"]}>
            { primaryName } | { primaryColor }
          </label>
        </CustomContainer>

      );
    }

    return (
      <>
        {__typename !== labels.lbl_product_typeName_simple && (
          <div
            className={
              !isVASProduct ? styles["cart-product--display-specs"] : styles[" "]
            }
          >
            { showModel || (dealOptions && dealOptions.length > 0)
              ? (
                <div className={styles["cart-product--value"]}>
                  <label>
                    { (optionValues && optionValues[0])
                      || (dealOptions && dealOptions[0])
                    }
                  </label>

                  { (optionValues && optionValues.length > 1)
                    || (dealOptions && dealOptions.length > 1)
                    ? (
                      <label className={styles["cart-product--value-line"]}>|</label>
                    ) 
                    : null
                  }
                </div>
              )
              : null
            }

            {(optionValues && optionValues.length > 1)
              || (dealOptions && dealOptions.length > 1)
              ? (
                <label className={styles["cart-product--value"]}>
                  {optionValues[1] || dealOptions[1]}
                </label>
              ) 
              : null
            }

            {__typename === labels.lbl_product_typeName_configurable && !isMobile 
              ? (
                <label className={styles.changeEvent} onClick={renderChangeLable}>
                  Change
                </label>
              )
              : null
            }
            
            { !!cartProduct?.colorSelection?.label && (
              <label className={styles["cart-product--value"]}>
                | { cartProduct?.colorSelection?.label }
              </label>
            )}
        
          </div>
        )}
      </>
    )
  }

  const renderSecondaryDeal = () => {

    const secondaryImg = cartProduct?.colorSelectionSecondary?.product?.image?.url;
    const secondaryName = cartProduct?.colorSelectionSecondary?.product?.name;
    const secondaryColor = cartProduct?.colorSelectionSecondary?.label;

    return (
      <CustomContainer className={styles["secondary-product"]}>
        <CustomContainer className={styles["product-image--secondary"]}>
          <Image
            img_path={secondaryImg}
            img_width="4rem"
            img_height="4rem"
            className={styles["product-image-style"]}
            alt="image"
          />
        </CustomContainer>

        <CustomContainer className={styles["secondary-product-details"]}>
          <label className={styles["secondary-product-details--title"]}>
            Secondary Device:
          </label>

          <label className={styles["secondary-product-details--device-name"]}>
            { secondaryName } | { secondaryColor }
          </label>

        </CustomContainer>

      </CustomContainer>
    );
  }

  const getHighlights = (item) => {
    const highlights = [
      {
        id: "1",
        value: "",
        displayUnit: "Anytime Data",
        unit: "promo_data",
        icon: `${imagePrefix}/assets/images/data.svg`,
      },
      {
        id: "2",
        value: "",
        displayUnit: "Night Owl Data",
        unit: "nightowl_units",
        icon: `${imagePrefix}/assets/images/data.svg`,
      },
      {
        id: "3",
        value: "",
        displayUnit: "voice minutes",
        unit: "minutes_label",
        icon: `${imagePrefix}/assets/images/phone.svg`,
      },
      {
        id: "4",
        value: "",
        displayUnit: "airtime",
        unit: "airtime",
        icon: `${imagePrefix}/assets/images/combo.svg`,
      },
      {
        id: "5",
        value: "",
        displayUnit: "SMSs",
        unit: "sms",
        icon: `${imagePrefix}/assets/images/sms.svg`,
      },
    ];
    highlights.forEach((highlight) => {
      highlight.value = item[highlight?.unit];
    });
    const newHighlight = highlights.filter((item) => {
      if (item.value > 0 || item.value == "Unlimited") {
        return item;
      }
    });
    const dataIndex = newHighlight.findIndex(
      (highLight) => highLight.unit === "promo_data"
    );
    if (dataIndex >= 0) {

      const title_promo = cartProduct?.product?.items?.find((promoName) => promoName.title === 'Promo');
      const getAnytime = title_promo.options?.find((promoSku) => promoSku.product?.sku === cartProduct?.product?.anytime_product_sku);

      newHighlight[dataIndex].value = getAnytime.product.promo_data != null
        ? `${formatBytes(getAnytime.product.promo_data)}`
        : `${formatBytes(newHighlight[dataIndex].value)}`;

    }
    const airtimeIndex = newHighlight.findIndex(
      (highLight) => highLight.unit === "airtime"
    );
    if (airtimeIndex >= 0) {
      newHighlight[airtimeIndex].value = `R${newHighlight[airtimeIndex].value}`;
    }
    const nightData = newHighlight.findIndex(
      (highLight) => highLight.unit === "nightowl_units"
    );
    if (nightData >= 0) {
      newHighlight[nightData].value =
        cartProduct?.product?.nightowl_uom != null
          ? `${newHighlight[nightData]?.value}${cartProduct?.product?.nightowl_uom}`
          : `${newHighlight[nightData].value}`;
    }
    return newHighlight;
  };

  const toggleDeal = () => {
    setShowDeal((deal) => !deal);
    let salesEvent;
    if (showDeal && !isMobile) {
      salesEvent = "hide deal details";
    } else if (showDeal && isMobile) {
      salesEvent = "hide details";
    } else {
      salesEvent = "show details";
    }
    const analyticsData = {
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal",
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_msisdn_hash",
        "visitor_id_hash",
      ]),
    };
    analyticsData.link_type = "o";
    analyticsData.link_name = `shopping: cart: ${salesEvent}`;
    Analytics.link(analyticsData);
  };

  const navigateToDealSelection = () => {
    setLoadingState(true);

    const analyticsData = {
      sales_event: "choose_another_deal",
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal",
      ...Analytics.getUtagData([
        "visitor_login_status",
        "visitor_subscription_type",
        "visitor_msisdn_hash",
        "visitor_id_hash",
      ]),
    };

    analyticsData.link_type = "o";
    analyticsData.link_name = "shopping: cart: choose another deal";

    Analytics.link(analyticsData);
    router.push(`${urlPrefix}/deals`).then(() => {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  return (
    <>
      {modalShow && !isMobile && (
        <ChangeLabelWithOutOfStock
          renderPage={renderPage}
          selectedOptions={optionObj}
          optList={optList}
          variant="cart"
          show={modalShow}
          centered
          onHide={() => setModalShow(false)}
          closeChangeable={closeChangeable}
          configProduct={
            __typename === labels.lbl_product_typeName_configurable
              ? cartProduct
              : null
          }
          originalPrice={finalPrice}
          buyOptionId={cartProduct?.config_custom_options?.[0]?.id}
          buyOptionTypeId={
            cartProduct?.config_custom_options?.[0]?.values?.[0]?.value
          }
        />
      )}

      <Row
        className={styles["cart-product"]}
        id={`${cartProduct?.id}` + "_cartProduct"}
      >
        <Col md={8}  className={styles["cart-product--display"]}>
          {!isVASProduct && (
            <Image
              img_path={small_image}
              img_width="5rem"
              img_height="5rem"
              className={styles["product-image-style"]}
              alt="image"
            />
          )}

          {isVASProduct && !isMobile && (
            <Image
              img_path={small_image}
              img_width="5rem"
              img_height="3.75rem"
              className={styles["product-image-style"]}
              alt="image"
            />
          )}
          <div className={!isVASProduct ? styles["cart-product--specs"] : styles["cart-vasproduct--specs"]}>
            {cartProduct?.hasBackOrderLabel && renderBackOrderTag()}
            {cartProduct?.hasPreOrderLabel && renderPreOrderTag()}
            {!!lowStockCount && !!lowStockFlag && renderLowStockTag()}

            <CustomContainer className={`d-flex ${styles["cart-product-header"]}`}>
              {!isVASProduct && (
                <label
                  className={
                    isDealProduct
                      ? styles["cart-product--deal-label"]
                      : styles["cart-product--label"]
                  }
                >
                  {name}
                </label>
              )}

              {isVASProduct && !isMobile && (
                <label
                  className={
                    isDealProduct
                      ? styles["cart-product--deal-label"]
                      : styles["cart-product--label"]
                  }
                >
                  {name}
                </label>
              )}

              {isDealProduct && (
                <>
                  <label
                    className={styles["deal-promo"]}
                  >{`on ${promoForDeal}`}</label>

                  {
                    <label
                      className={styles["show-details"]}
                      onClick={toggleDeal}
                    >
                      {showDeal
                        ? !isMobile
                          ? "Hide deal details"
                          : ""
                        : "Show details"}
                    </label>
                  }
                </>
              )}

            </CustomContainer>

            {!isMobile && (
              <CustomContainer>
                {isVASProduct && (
                  <>
                    <div className={styles["cart-vas-desc"]}>
                      <label className={styles["cart-vas-desc--text"]}>
                        <div
                          dangerouslySetInnerHTML={createMarkup(
                            vasDescription?.html
                          )}
                        ></div>
                      </label>
                    </div>
                  </>
                )}
              </CustomContainer>
            )}

            { renderRenderSelectedSpecs() }

            { cartProduct?.isDoubleDeal && renderSecondaryDeal() }

            {isDealProduct && (
              <>
                {showDeal && (
                  <CustomContainer className={styles["deal-includes"]}>
                    <LabelText className={styles["this-deal-heading"]}>
                      This deal includes:
                    </LabelText>

                    <CustomContainer
                      className={`${styles["detail-container"]}`}
                    >
                      <CustomContainer
                        className={styles["highlights-container"]}
                      >
                        {getHighlights(cartProduct?.product).map((item) => (
                          <IconWithText
                            key={item.id}
                            icon={item.icon}
                            value={item.value}
                            description={item.displayUnit}
                            imageClass={styles.img}
                            valueStyle={styles.value}
                            typeStyle={styles.type}
                            className={styles["icon-text"]}
                            descriptionStyle={styles.description}
                          />
                        ))}
                      </CustomContainer>

                      {nonPromoArray.map((value, index) => (
                        <IconWithText
                          key={`promo-${index}`}
                          icon={`${imagePrefix}/assets/images/add-copy.svg`}
                          value={value}
                          imageClass={styles.img}
                          valueStyle={styles.value}
                          className={styles["icon-text"]}
                          descriptionStyle={styles.description}
                        />
                      ))}
                    </CustomContainer>
                    {!isMobile && (
                      <label
                        className={styles["change-deal"]}
                        onClick={navigateToDealSelection}
                      >
                        Change Deal
                      </label>
                    )}
                  </CustomContainer>
                )}
              </>
            )}

            {isMobile && (
              <label className={styles["hide-details"]} onClick={toggleDeal}>
                {showDeal && "Hide details"}
              </label>
            )}

            {promoSection}
            {vasSection}
          </div>

          {isVASProduct && isMobile && (
            <CustomContainer>
              <CustomContainer>
                <Image
                  img_path={small_image}
                  className={styles["vasProduct-image-style"]}
                  alt="image"
                />

                <label className={styles["vasProduct-label"]}>{name}</label>
              </CustomContainer>

              <div className={styles["cart-vas-desc"]}>
                <label className={styles["cart-vas-desc--text"]}>
                  <div
                    dangerouslySetInnerHTML={createMarkup(vasDescription.html)}
                  ></div>
                </label>
              </div>
            </CustomContainer>
          )}

          {isMobile && (
            <Image
              img_path={`${imagePrefix}/assets/images/menu-dots.svg`}
              img_width="20px"
              img_height="20px"
              className={styles["cart-product--price-container"]}
              onClick={showOptions}
              id={`${cartProduct?.id}-options`}
            />
          )}
        </Col>

        {isMobile && (
          <Col xs={12} className={styles["price-container"]}>
            {!isDealProduct && !isVASProduct && (
              <div style={{ display: "inline-block" }}>
                <StepCounter
                  id={cartProduct?.id}
                  value={cartProductQuantity}
                  stepDecrement={stepDecrement}
                  stepIncrement={stepIncrement}
                  totalQuantity={totalQuantity}
                  disableIncrement={
                    lowStockFlag && lowStockCount === cartProductQuantity
                      ? true
                      : false
                  }
                />
              </div>
            )}
            {PriceComponent}
          </Col>
        )}

        {!isMobile && RenderRightComponent}
      </Row>

      {showModal && (
        <Modal
          show={showModal}
          onHide={closeOptions}
          dialogClassName="custom-dialog"
        >
          <CartProductOptions
            renderPage={renderPage}
            selectedOptions={optionObj}
            optList={optList}
            variant="cart"
            cartProduct={cartProduct}
            show={showModal}
            originalPrice={finalPrice}
            onHide={closeOptions}
            selectedVariant={selectedVariant}
            removeCartProduct={(cartid, id, name, isDealProduct) =>
              removeCartProduct(cartid, id, name, isDealProduct)
            }
            updateCartProduct={(cartId, id, qty, name, isDealProduct) =>
              updateCartProduct(cartId, id, qty, name, isDealProduct)
            }
            promoTag={promoTag}
            disableIncrement={
              lowStockFlag && lowStockCount === cartProductQuantity
                ? true
                : false
            }
            isRenderActiveStepCounter={isRenderStepCounter()}
            changeDeal={navigateToDealSelection}
            buyOptionId={cartProduct?.config_custom_options?.[0]?.id}
            buyOptionTypeId={
              cartProduct?.config_custom_options?.[0]?.values?.[0]?.value
            }
          />
        </Modal>
      )}
    </>
  );
};

CartProductCard.propTypes = {
  cartProduct: PropTypes.object,
  deleteItemsFromCart: PropTypes.func,
  updateItemsofCart: PropTypes.func,
  dealSku: PropTypes.arrayOf(PropTypes.string),
  removeCartProduct: PropTypes.func,
  updateCartProduct: PropTypes.func,

  // Redux
  cartProductItems: PropTypes.arrayOf(PropTypes.object),
  totalQuantity: PropTypes.number,
};

const mapStateToProps = (state) => ({
  totalQuantity: state.cartDetails?.totalQuantity,
  cartProductItems: state.cartDetails?.cartProductItems,
});

export default connect(mapStateToProps)(CartProductCard);
